<div class="card" *ngIf="listaFornecedores.length == 1">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">CNPJ</h6>
                <p>{{(fornecedor.cnpj | bnMask: 'CNPJ') || '-'}}</p>
            </div>
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Razão Social</h6>
                <p>{{fornecedor.nome || '-'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3 col-12" *ngIf="fornecedor.dataDeConstituicao">
                <h6 class="mb-0">Data de Constituição</h6>
                <p>{{(fornecedor.dataDeConstituicao | date: 'dd/MM/yyyy') || '-'}}</p>
            </div>
            <div class="col-sm-5 col-12" *ngIf="fornecedor.naturezaDaEmpresa">
                <h6 class="mb-0">Natureza da Empresa</h6>
                <p>{{fornecedor.naturezaDaEmpresa || '-'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-5 col-12" *ngIf="fornecedor.capitalSocialNome">
                <h6 class="mb-0">Caracterização do Capital Social</h6>
                <p>{{fornecedor.capitalSocialNome || '-'}}</p>
            </div>
        </div>
        
        <div *ngIf="(fornecedor.robTipo || fornecedor.robValor || fornecedor.robData || fornecedor.porteNome)">
            <hr class="hr"/>
            <h5>ROB</h5>
            <div class="row">
                <div class="col-sm-1 col-12" *ngIf="fornecedor.robTipo">
                    <h6 class="mb-0">Tipo</h6>
                    <p>{{fornecedor.robTipo || '-'}}</p>
                </div>
                <div class="col-sm-2 col-12" *ngIf="fornecedor.robValor">
                    <h6 class="mb-0">Valor (R$)</h6>
                    <p>{{fornecedor.robValor || '-'}}</p>
                </div>
                <div class="col-sm-2 col-12" *ngIf="fornecedor.robData">
                    <h6 class="mb-0">Data de Referência</h6>
                    <p>{{(fornecedor.robData | date: 'dd/MM/yyyy') || '-'}}</p>
                </div>
                <div class="col-sm-3 col-12" *ngIf="fornecedor.porteNome">
                    <h6 class="mb-0">Porte</h6>
                    <p>{{fornecedor.porteNome || '-'}}</p>
                </div>
            </div>
        </div>

        <div *ngIf="(fornecedor.grupoRobTipo || fornecedor.grupoRobValor || fornecedor.grupoRobData || fornecedor.grupoCnpjLider)">
            <hr class="hr"/>
            <h5>ROB do grupo ao qual pertence</h5>
            <div class="row">
                <div class="col-sm-1 col-12" *ngIf="fornecedor.robTipo">
                    <h6 class="mb-0">Tipo</h6>
                    <p>{{fornecedor.grupoRobTipo || '-'}}</p>
                </div>
                <div class="col-sm-2 col-12" *ngIf="fornecedor.robValor">
                    <h6 class="mb-0">Valor (R$)</h6>
                    <p>{{fornecedor.grupoRobValor || '-'}}</p>
                </div>
                <div class="col-sm-2 col-12" *ngIf="fornecedor.robData">
                    <h6 class="mb-0">Data de Referência</h6>
                    <p>{{(fornecedor.grupoRobData | date: 'dd/MM/yyyy') || '-'}}</p>
                </div>
                <div class="col-sm-3 col-12" *ngIf="fornecedor.grupoCnpjLider">
                    <h6 class="mb-0">CNPJ do Lider do Grupo</h6>
                    <p>{{(fornecedor.grupoCnpjLider | bnMask: 'CNPJCPF') || '-'}}</p>
                </div>
            </div>
        </div>
        <div *ngIf="(fornecedor.logradouro || fornecedor.cep || fornecedor.bairro || fornecedor.municipio || fornecedor.uf)">
            <hr class="hr"/>
            <h5>Endereco Sede</h5>
            <div class="row">
                <div class="col-sm-5 col-12" *ngIf="fornecedor.logradouro">
                    <h6 class="mb-0">Logradouro</h6>
                    <p>{{fornecedor.logradouro || '-'}}</p>
                </div>
                <div class="col-sm-3 col-12" *ngIf="fornecedor.cep">
                    <h6 class="mb-0">CEP</h6>
                    <p>{{(fornecedor.cep | bnMask: 'CEP') || '-'}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 col-12" *ngIf="fornecedor.bairro">
                    <h6 class="mb-0">Bairro</h6>
                    <p>{{fornecedor.bairro || '-'}}</p>
                </div>
                <div class="col-sm-2 col-12" *ngIf="fornecedor.municipio">
                    <h6 class="mb-0">Município</h6>
                    <p>{{fornecedor.municipio || '-'}}</p>
                </div>
                <div class="col-sm-3 col-12" *ngIf="fornecedor.uf">
                    <h6 class="mb-0">UF</h6>
                    <p>{{fornecedor.uf || '-'}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card" *ngIf="listaFornecedores.length > 1">
    <div class="card-body">
        <table class="table table-hover table-sm table-striped">
            <thead>
                <tr>
                    <th scope="col" class="col-sm-1">CNPJ</th>
                    <th scope="col" class="col-sm-5">Razão Social</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fornecedor of listaFornecedores">
                    <td class="col-sm-1">{{(fornecedor.cnpj | bnMask: 'CNPJ') || '-'}}</td>
                    <td class="col-sm-5">{{fornecedor.nome || '-'}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
